import { ChainId } from '../constant';
import { Client } from './type';

export default {
    [ChainId.lazaiTestnet]: {
        [Client.graph]: 'https://task.lazai.network/lazai',
    },
};
